import { Settings2 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator
} from '@/components/ui/DropdownMenu';
import { COLUMNS } from '@/lib/dashboardColumns';

type Props = {
  visible: string[];
  onChange: (cols: string[]) => void;
};

export function ColumnConfigDropdown({ visible, onChange }: Props) {
  function toggle(key: string): void {
    if (visible.includes(key)) {
      onChange(visible.filter((k) => k !== key));
    } else {
      onChange([...visible, key]);
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex min-h-[44px] items-center gap-2 rounded-md border border-line bg-cream px-3 py-2 text-sm text-ink-soft hover:border-akzent hover:text-akzent"
          aria-label="Spalten konfigurieren"
        >
          <Settings2 className="h-4 w-4" />
          Spalten
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>Sichtbare Spalten</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {COLUMNS.map((c) => (
          <DropdownMenuItem
            key={c.key}
            onSelect={(e) => {
              e.preventDefault();
              toggle(c.key);
            }}
          >
            <span
              aria-hidden
              className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded border border-line"
            >
              {visible.includes(c.key) && (
                <span className="h-2 w-2 rounded-sm bg-akzent" />
              )}
            </span>
            {c.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
